export default __webpack_public_path__ + "static/media/teamwork-polygon.b47fe1f1.png";